import { useState } from 'react';

const faqs = [
  {
    q: 'Cos\'è Itaobuy Spreadsheet?',
    a: 'Itaobuy Spreadsheet è una piattaforma moderna che combina funzionalità di foglio di calcolo con strumenti avanzati di gestione dati. Progettata per utenti di ogni livello, offre un\'interfaccia intuitiva per organizzare, analizzare e condividere informazioni in modo efficiente. A differenza dei tradizionali fogli di calcolo, itaobuy sheet integra automazioni intelligenti e template pronti all\'uso che semplificano il lavoro quotidiano.',
  },
  {
    q: 'Itaobuy Spreadsheet è sicuro?',
    a: 'Sì, la sicurezza dei dati è una priorità assoluta per itaobuy sheet. La piattaforma utilizza crittografia avanzata per proteggere le tue informazioni, sistemi di backup automatici e controlli di accesso granulari. Prima di utilizzare qualsiasi strumento digitale, è importante conoscere le impostazioni di protezione dell\'account, la gestione delle password, le policy sulla privacy e le migliori pratiche per mantenere i tuoi dati al sicuro.',
  },
  {
    q: 'Come utilizzare Itaobuy Spreadsheet?',
    a: 'Utilizzare itaobuy sheet è semplice e intuitivo. Dopo aver effettuato l\'accesso alla piattaforma, puoi creare nuovi fogli di calcolo, importare dati esistenti o partire da uno dei numerosi template disponibili. L\'interfaccia è progettata per essere familiare agli utenti di Excel e Google Sheets, con una curva di apprendimento molto bassa. Sono disponibili guide passo passo e tutorial in italiano per aiutarti a iniziare.',
  },
  {
    q: 'Quali sono le alternative a Itaobuy Spreadsheet?',
    a: 'Le principali alternative a itaobuy sheet includono Microsoft Excel e Google Sheets. Excel offre funzionalità avanzate ma ha un costo di licenza e funzionalità online limitate. Google Sheets è gratuito e basato sul cloud ma ha capacità di automazione più limitate. Itaobuy Spreadsheet si posiziona come una soluzione equilibrata, combinando la potenza di Excel con la praticità cloud di Google Sheets, aggiungendo funzionalità uniche di automazione e template specializzati.',
  },
  {
    q: 'Dove trovare informazioni aggiornate su Itaobuy Spreadsheet?',
    a: 'Puoi trovare informazioni aggiornate su itaobuy sheet visitando il sito ufficiale e consultando le nostre guide e recensioni. Questa piattaforma viene costantemente aggiornata con nuove funzionalità, tutorial e consigli pratici. Ti consigliamo di visitare regolarmente il nostro sito per rimanere aggiornato sulle ultime novità e sulle migliori pratiche di utilizzo.',
  },
  {
    q: 'Itaobuy Spreadsheet ha un costo?',
    a: 'Itaobuy sheet offre diverse opzioni per soddisfare le esigenze di ogni utente. Sono disponibili piani gratuiti con funzionalità base e piani premium con strumenti avanzati, maggiore spazio di archiviazione e supporto prioritario. Per conoscere i prezzi aggiornati e le funzionalità incluse in ciascun piano, ti consigliamo di visitare il sito ufficiale.',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="w-full bg-background-100 py-20 md:py-28" id="faq">
      <div className="max-w-3xl mx-auto px-4 md:px-6 lg:px-10">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground-950 font-heading">
            Domande <span className="italic font-normal">Frequenti</span>
          </h2>
          <p className="mt-3 text-base text-foreground-600 font-body">
            Tutto quello che devi sapere su itaobuy sheet in un unico posto.
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="rounded-2xl bg-background-50 border border-background-200/60 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                className="w-full flex items-center justify-between px-6 py-4 text-left cursor-pointer"
              >
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 pr-4 font-label">
                  {faq.q}
                </h3>
                {openIndex === idx ? (
                  <i className="ri-arrow-up-s-line text-foreground-400 text-lg flex-shrink-0"></i>
                ) : (
                  <i className="ri-arrow-down-s-line text-foreground-400 text-lg flex-shrink-0"></i>
                )}
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === idx ? 'max-h-96 pb-4 px-6' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-600 font-body leading-relaxed">
                  {faq.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}